export const plansColumn = [
	'mb.plans.column-marketing_bulk_sms',
	'mb.plans.column-mobile_pbx',
	'mb.plans.column-domain',
	'mb.plans.column-web_hosting',
	'mb.plans.column-microsoft_365',
];

export const addons = ['mb.package.domain', 'mb.package.web_hosting', 'mb.package.mobile_pbx'];

export const PLANS_PER_PAGE = 3;

export const PLANS_PER_PAGE_MOB = 1;

export const SERVICES = {
	MOBILE_PBX: 'mobile_pbx',
	WEB_HOSTING: 'web_hosting',
	MICROSOFT: 'microsoft_365',
	CONTRACT: 'contract',
};
export const formData = [
	{
		id: 1,
		label: 'mb.form.label.your.plan',
		required: true,
		readOnly: true,
		name: 'plan',
	},
	{
		id: 2,
		label: 'mb.form.label.your.name',
		required: true,
		name: 'name',
		isEditable: true,
	},
	{
		id: 4,
		label: 'mb.form.label.your.contact',
		required: true,
		name: 'contactNumber',
		type: 'number',
		isEditable: true,
	},
	{
		id: 5,
		label: 'mb.form.label.your.email',
		required: true,
		name: 'email',
		isEditable: true,
	},
];

export const WEB_PLAN_INFO = 'WEB_PLAN_INFO';
export const ARBOR_E_FORM_ID = 'ARBOR_E_FORM_ID';
export const MARKETING_SMS = 'marketing sms';
export const OFFER = 'Offer';
export const DISPLAY = 'Display';
export const SERVICE_STATUS = {
	ACTIVE: 'active',
	PENDING: 'pending',
	PENDING_ACTIVATION: 'pending activation',
};

export const ROUTES = {
	SERVICES: '/dashboard/services',
	ADD_SERVICES: '/dashboard/services/add/',
	ADD_NEW_MB: '/aamali-plus',
	NUMBERS: '/dashboard/numbers',
	MY_BILLS: '/dashboard/payments/bills?paymentPreference=BM',
	BOM_PAYMENT_STATUS: '/dashboard/payments/payments-requests'

};

export const discountAttribute = 'discount';
export const downloadSpeedAttribute = 'download_speed';
export const SUCCESS = 'success';
export const FAILURE = 'failure';

export const TAB_INDEXES = {
	LOCATION: 1,
	PLANS: 0,
	// BENEFITS: 1,
	FORM: 2,
};

export const MK_SMS_PART_NUMBERS = ['18972', '18966'];
export const MK_365_PART_NUMBERS = ['18969', '18970'];
